import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from "react";
import { Switch } from "@/components/ui/switch";
import { Label } from "@/components/ui/label";
import { Checkbox } from "@/components/ui/checkbox";
import { formatIngredient } from "../../utils/recipeHelpers";
export function IngredientsSection({ ingredients, className = "", }) {
    const [useMetric, setUseMetric] = useState(false);
    const [checkedIngredients, setCheckedIngredients] = useState(new Set());
    const toggleIngredient = (id) => {
        setCheckedIngredients((prev) => {
            const newSet = new Set(prev);
            if (newSet.has(id)) {
                newSet.delete(id);
            }
            else {
                newSet.add(id);
            }
            return newSet;
        });
    };
    return (_jsxs("div", { className: `bg-[#faf8f5] border border-[#e8e3db] rounded-lg p-6 recipe-print-section recipe-print-ingredients ${className}`, children: [_jsxs("div", { className: "flex items-center justify-between mb-6", children: [_jsx("h2", { className: "text-[#5a4a3a]", children: "Ingredients" }), _jsxs("div", { className: "flex items-center gap-2 no-print", children: [_jsx(Label, { htmlFor: "unit-toggle", className: `text-sm ${!useMetric ? "text-[#5a4a3a]" : "text-[#5a4a3a]/50"}`, children: "Imperial" }), _jsx(Switch, { id: "unit-toggle", checked: useMetric, onCheckedChange: setUseMetric }), _jsx(Label, { htmlFor: "unit-toggle", className: `text-sm ${useMetric ? "text-[#5a4a3a]" : "text-[#5a4a3a]/50"}`, children: "Metric" })] })] }), _jsx("ul", { className: "space-y-3", children: ingredients.map((ingredient, index) => {
                    const ingredientId = ingredient.id || `ingredient-${index}`;
                    const isChecked = checkedIngredients.has(ingredientId);
                    return (_jsxs("li", { className: "flex items-start gap-3 group", children: [_jsx(Checkbox, { id: ingredientId, checked: isChecked, onCheckedChange: () => toggleIngredient(ingredientId), className: "mt-1 flex-shrink-0 no-print" }), _jsx("label", { htmlFor: ingredientId, className: `flex-1 cursor-pointer transition-all ${isChecked
                                    ? "line-through text-[#5a4a3a]/50"
                                    : "text-[#5a4a3a]"}`, children: formatIngredient(ingredient, useMetric) })] }, ingredientId));
                }) })] }));
}
